/*
yogeshsrigiri  09/23/2022 3075414077  implemented breadcrumbs for all the side menu pages
yogeshsrigiri  10/31/2022 3075414077  Added tab values and classname for selected add account
Raghu 11/16/2022 3075414077 Card styling fixes
*/
import {Card} from '@material-ui/core';
import React, {useContext} from 'react';
import LandingPage from '../../Pages/LandingPage';
import {ThemeContext} from '../../themes/ThemeProvider';
import CreateAccount from './CreateAccount';
function index() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const tabLabels = ['Add Account'];
  return (
    <>
      <LandingPage showTabs={true} title={'New Business Maintenance'} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}>
        <div className={`global-field-dash-board`}>
          <Card className={`${classes.cardBordernoneStyles} rounded`} elevation={0}>
            <CreateAccount />
          </Card>
        </div>
      </LandingPage>
    </>
  );
}

export default index;
